import Utils from "../../../../../shared/utils";

export const SECOND_SECTION_IMAGE = Utils.buildProductPageImageLink("mort/complete-mort/second-section.svg")
